import React from "react";
import "./enterprises-premises.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { GatsbyImage } from "gatsby-plugin-image";

const EnterprisesPremises = (props: ReferenciaContenido) => {
  const premises = props;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="m-premises-container">
      <div className="m-premises-container__desc">
        <span>{premises.tituloGeneral}</span>
        <p>
          {premises.descripcion &&
            JSON.parse(premises.descripcion.raw)?.content[0]?.content[0]?.value}
        </p>
      </div>
      <div className="m-premises-container__content">
        <Slider {...settings}>
          {premises.referenciaPlantillaContenido.map((value, key) => {
            return (
              <div
                className="m-premises-container__content-cardSlider"
                key={key}
              >
                <GatsbyImage
                  image={value.imagenPrincipal[0].gatsbyImageData}
                  alt={value.imagenPrincipal[0].title}
                />
                <p>{value.tituloBanner}</p>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default EnterprisesPremises;
